/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Spin, Switch, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import "../Styles/AuditTable.css";
import { useDispatch, useSelector } from "react-redux";
import Axios from "../../../../../api/Axios";
import {
  CheckOutlined,
  CloseOutlined,
  FileExcelFilled,
  FilePdfOutlined,
} from "@ant-design/icons";
import { setAuditFilterDataRedux } from "../../../../../store/slices/auditfilterSlice";
import { setEmailFilterDataRedux } from "../../../../../store/slices/emailfilterSlice";
import AuditFilterModal from "../Modals/FilterModal";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../../components/icons/ApplicationColor";
import { BASE_URL } from "../../../../../config";
import CommonTopDetails from "../../../../../components/AdminComponents/CommonTopDetails";

const AuditTable = () => {
  const [active, setActive] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  // l1,l2,l3 names
  const [l1name, setL1Name] = useState("");
  const [l2name, setL2Name] = useState("");
  const [l3name, setL3Name] = useState("");

  const [itemsLength, setItemsLength] = useState();

  const [searchString, setSearchString] = useState("");
  // filter related states
  const [L1Filters, setL1Filters] = useState([]);
  const [L2Filters, setL2Filters] = useState([]);
  const [L3Filters, setL3Filters] = useState([]);

  const [selectedL1Filter, setselectedL1Filter] = useState(null);
  const [selectedL2Filter, setselectedL2Filter] = useState(null);
  const [selectedL3Filter, setselectedL3Filter] = useState(null);

  const clientInfo = useSelector((state) => state.user);
  const filterDataRedux = useSelector((state) => state.auditfilter);
  const { sort_column, sort_order, pageSize, currentPage } = filterDataRedux;

  const dispatch = useDispatch();
  const id = clientInfo.data.organization.id;

  const showModal = () => {
    setVisible(true);
  };

  // eslint-disable-next-line no-unused-vars
  const items = [
    {
      label: "PDF",
      key: "1",
      icon: <FilePdfOutlined />,
    },
    {
      label: "Excel",
      key: "2",
      icon: <FileExcelFilled />,
      disabled: true,
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const handleMenuClick = (e) => {
    //console.log("Clicked", e)
    var url = `${BASE_URL}/generate/${clientInfo.data.organization.id}/audit/pdf/?`;
    if (selectedL1Filter) {
      url += `entity_id=${selectedL1Filter}`;
    }
    if (selectedL2Filter) {
      url += `&division_id=${selectedL2Filter}`;
    }
    if (selectedL3Filter) {
      url += `&department_id=${selectedL3Filter}`;
    }
    var win = window.open(url, "_blank");
    win.focus();
  };
  // const menuProps = {
  //   items,
  //   onClick : handleMenuClick,

  // }

  const onShowSizeChange = (page, size) => {
    //console.log(size, "clientFilter");
    dispatch(
      setAuditFilterDataRedux({
        ...filterDataRedux,
        pageSize: size,
        newPageSize: "sdkds",
      })
    );
    onPageChange(page, size);
  };

  const onPageChange = (page, size) => {
    dispatch(
      setAuditFilterDataRedux({
        ...filterDataRedux,
        currentPage: page,
        pageSize: size,
      })
    );
  };

  const handleSortChange = (pagination, filters, sorter) => {
    dispatch(
      setAuditFilterDataRedux({
        ...filterDataRedux,
        sort_column: sorter.field || "",
        sort_order: sorter.order
          ? sorter.order === "ascend"
            ? "asc"
            : "desc"
          : "",
        url: "/audittrail/",
      })
    );
  };

  const handleSearchChange = (event) => {
    setSearchString(event.target.value);
    dispatch(
      setAuditFilterDataRedux({
        ...filterDataRedux,
        search: event.target.value,
        currentPage: 1,
        url: "/audittrail/",
      })
    );
  };

  const handleSwitchChange = (checked) => {
    setActive(checked);
    const newFilterData = {
      search: "",
      currentPage: 1,
      activeRedux: checked,
      url: "/audittrail/",
      itemsLength: Math.floor(Math.random() * 100),
      filter_flag: false,
    };
    dispatch(setAuditFilterDataRedux(newFilterData));
  };

  const fetchTableData = async () => {
    //console.log('Fetching table data with:', filterDataRedux);
    setLoading(true);
    const { search, pageSize, currentPage } = filterDataRedux;
    let passUrl = `/audittrail/${id}/?page=${currentPage}&page_size=${pageSize}&login_status=${
      active ? "SUCCESS" : "FAILURE"
    }`;
    if (sort_column && sort_order) {
      passUrl += `&sort_column=${sort_column}&sort_order=${sort_order}`;
    }
    if (search && search.length > 2) {
      passUrl += `&search=${search ? search : searchString}`;
    }
    if (selectedL1Filter) {
      passUrl += `&entity_id=${selectedL1Filter}`;
    }
    if (selectedL2Filter) {
      passUrl += `&division_id=${selectedL2Filter}`;
    }
    if (selectedL3Filter) {
      passUrl += `&department_id=${selectedL3Filter}`;
    }

    try {
      const res = await Axios.get(passUrl);
      setData(res.data.results.data);
      setL1Name(res.data.results.l1_name);
      setL2Name(res.data.results.l2_name);
      setL3Name(res.data.results.l3_name);
      setItemsLength(res.data.count);
      dispatch(
        setAuditFilterDataRedux({
          ...filterDataRedux,
          l1name: res.data.results.l1_name,
          l2name: res.data.results.l2_name,
          l3name: res.data.results.l3_name,
        })
      );
      dispatch(
        setEmailFilterDataRedux({
          l1name: res.data.results.l1_name,
          l2name: res.data.results.l2_name,
          l3name: res.data.results.l3_name,
        })
      );
    } catch (err) {
      console.error(err);
      setLoading(false);
    } finally {
      L1Filter();
    }
    setLoading(false);
  };

  const ResetFields = () => {
    let randomItemsLength = Math.floor(Math.random() * 100);

    setL2Filters([]);
    setL3Filters([]);
    setselectedL1Filter(null);
    setselectedL2Filter(null);
    setselectedL3Filter(null);
    dispatch(
      setAuditFilterDataRedux({
        ...filterDataRedux,
        pageSize: 15,
        currentPage: 1,
        url: `/audittrail/${id}`,
        filter_flag: false,
        search: "",
        itemsLength: randomItemsLength,
        l1filters: "",
        l2filters: "",
        l3filters: "",
        selectedl1filters: "",
        selectedl2filters: "",
        selectedl3filters: "",
      })
    );
    setVisible(false);
    setActive(active);
  };

  const L1Filter = async () => {
    try {
      const res = await Axios.get(`/hirarchylist/?hierarchy=Level1&find=${id}`);
      setL1Filters(res.data.structure);
      dispatch(
        setAuditFilterDataRedux({
          l1filters: res.data.structure,
          l1name: l1name,
          l2name: l2name,
          l3name: l3name,
        })
      );
    } catch (err) {
      console.error(err);
    }
  };

  const L2Filter = async () => {
    if (selectedL1Filter) {
      try {
        const res = await Axios.get(
          `/hirarchylist/?hierarchy=Level2&find=${selectedL1Filter}`
        );
        setL2Filters(res.data.structure);
        setselectedL2Filter(res.data.structure[0].id);
        dispatch(
          setAuditFilterDataRedux({
            selectedl1filters: selectedL1Filter,
            l1name: l1name,
            l2name: l2name,
            l3name: l3name,
          })
        );
        L3Filter();
      } catch (err) {
        console.error(err);
      }
    }
  };

  const L3Filter = async () => {
    if (selectedL2Filter) {
      try {
        const res = await Axios.get(
          `/hirarchylist/?hierarchy=Level3&find=${selectedL2Filter}`
        );
        setL3Filters(res.data.structure);
        setselectedL3Filter(res.data.structure[0].id);
        dispatch(
          setAuditFilterDataRedux({
            selectedl2filters: selectedL2Filter,
            l1name: res.data.l1_name,
            l2name: res.data.l2_name,
            l3name: res.data.l3_name,
          })
        );
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleApply = async () => {
    //console.log("IN HANDLE APPLY");
    setLoading(true);
    let passUrl = `/audittrail/${id}/?login_status=${
      active ? "SUCCESS" : "FAILURE"
    }`;
    if (!selectedL1Filter) {
      passUrl += `&page=${currentPage}&page_size=${pageSize}`;
    } else {
      passUrl += `&page=1&page_size=15`;
    }
    if (selectedL1Filter) {
      passUrl += `&entity_id=${selectedL1Filter}`;
    }
    if (selectedL2Filter) {
      passUrl += `&division_id=${selectedL2Filter}`;
    }
    if (selectedL3Filter) {
      passUrl += `&department_id=${selectedL3Filter}`;
    }

    try {
      const res = await Axios.get(passUrl);
      dispatch(
        setAuditFilterDataRedux({
          ...filterDataRedux,
          pageSize: 15,
          currentPage: 1,
        })
      );
      setData(res.data.results.data);
      setItemsLength(res.data.count);
      setVisible(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [
    active,
    filterDataRedux.pageSize,
    filterDataRedux.currentPage,
    filterDataRedux.itemsLength,
  ]);
  useEffect(() => {
    if (searchString.length > 2) {
      fetchTableData();
    } else if (searchString.length === 0) {
      fetchTableData();
    }
  }, [searchString]);
  useEffect(() => {
    L2Filter();
  }, [selectedL1Filter]);

  useEffect(() => {
    L3Filter();
  }, [selectedL2Filter]);

  const renderStatus = (text, record) => {
    if (record.is_logged_in) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else if (record.status === "SUCCESS") {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tooltip title={record.login_failed_reason}>
              <CloseOutlined
                style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
              />
            </Tooltip>
          </div>
        </div>
      );
    }
  };

  const failedColumns = [
    {
      title: "USER ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 120,
    },
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      width: 120,
    },
    {
      title: `${l3name}` || "Loading",
      dataIndex: "dept_name",
      key: "dept_name",
    },
    {
      title: "ATTEMPTED AT",
      dataIndex: "login_time",
      key: "login_time",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      // defaultSortOrder: getDefaultSortOrder("name"),
      render: (text, record) => {
        const date = new Date(record.login_time);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.login_time) {
          return `${day} ${month} ${year} ${hours}:${minutes}:${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
    {
      title: "IP",
      dataIndex: "user_ip",
      key: "user_ip",
      width: 140,
    },
    {
      title: "FAILURE REASON",
      dataIndex: "login_failed_reason",
      key: "login_failed_reason",
    },
  ];

  const columns = [
    {
      title: capitalizeWords("USER ID"),
      dataIndex: "user_id",
      key: "user_id",
    },
    {
      title: capitalizeWords("NAME"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: capitalizeWords(`${l3name}` || "Loading"),
      dataIndex: "dept_name",
      key: "dept_name",
    },
    {
      title: capitalizeWords("LOGIN TIME"),
      dataIndex: "login_time",
      key: "login_time",
      sorter: true,
      width: 250,
      sortDirections: ["ascend", "descend"],
      // defaultSortOrder: getDefaultSortOrder("name"),
      render: (text, record) => {
        const date = new Date(record.login_time);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.login_time) {
          return `${day} ${month} ${year} ${hours}:${minutes}:${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
    {
      title: capitalizeWords("LOGOUT TIME"),
      dataIndex: "logout_time",
      key: "logout_time",
      sorter: true,
      width: 250,
      render: (text, record) => {
        const date = new Date(record.logout_time);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        if (record.logout_time) {
          return `${day} ${month} ${year} ${hours}:${minutes}:${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
    {
      title: capitalizeWords("IP"),
      dataIndex: "user_ip",
      key: "user_ip",
      width: 140,
    },
    {
      title: capitalizeWords("STATUS"),
      dataIndex: "login_status",
      key: "login_status",
      align: "center",
      render: (text, record) => {
        if (record.login_status === "SUCCESS") {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  width: "1.8rem",
                  height: "1.8rem",
                  borderRadius: "50%",
                  backgroundColor: "#52c41a",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CheckOutlined
                  style={{
                    color: "#fff",
                    fontSize: "1.2rem",
                    fontWeight: "700",
                  }}
                />
              </div>
            </div>
          );
        } else {
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: "1.8rem",
                height: "1.8rem",
                borderRadius: "50%",
                backgroundColor: "#52c41a",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CloseOutlined
                style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
              />
            </div>
          </div>;
        }
      },
    },
    {
      title: capitalizeWords("ONLINE"),
      dataIndex: "is_logged_in",
      key: "is_logged_in",
      align: "center",
      render: renderStatus,
    },
  ];

  return (
    <>
      <CommonTopDetails
        title={active ? "Audit Logs" : "Failed Logs"}
        titleSuffix={`${itemsLength || 0} client(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={true}
        marginPass="15px"
        filterUrl={false}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        resetButtonProps={{
          modalProps: ResetFields,
        }}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            onChange={handleSwitchChange}
            // disabled={loading}
            checkedChildren="SUCCESS"
            unCheckedChildren="FAILED"
          />
        }
      />
      {/* <div style={{ display: "flex", alignItems: "center" }}>
        <div className="search-container">
          <div
            className="heading-text"
            style={{ display: "flex", alignItems: "center" }}
          >
            {active ? (
              "AUDIT LOGS"
            ) : (
              <span>
                <span style={{ color: "#FF0000" }}> FAILED </span> LOGS
              </span>
            )}{" "}
            |{" "}
            <span className="gold-text-span" style={{ paddingLeft: "2.5px" }}>
              {data?.length} Logs(s)
            </span>
          </div>
          <div className="other-icons" style={{ paddingTop: "2.5px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "1rem",
                }}
              >
                <Dropdown menu={menuProps}>
            <Button style={{
              backgroundColor : "#f58029",
              color: "white",
              borderRadius : "8px"
            }}>
              <Space>
                Export As
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
              </div>
              <Badge dot={false} color="red">
                <div
                  style={{
                    backgroundColor: "#5c7cfa",
                    width: "24px",
                    height: "24px",
                    padding: "2px",
                    marginTop: "0.25rem",
                    marginBottom: "0.3rem",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={showModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-160q-17 0-28.5-11.5T400-200v-240L161-745q-14-17-4-36t31-19h584q21 0 31 19t-4 36L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-276 240-304H240l240 304Zm0 0Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </Badge>
              <Tooltip title="Reset Filters">
                <div
                  style={{
                    backgroundColor: "gray",
                    width: "24px",
                    height: "24px",
                    padding: "2px",
                    marginRight: "1rem",
                    marginLeft: "1rem",
                    borderRadius: "5px",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  onClick={ResetFields}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M451-122q-123-10-207-101t-84-216q0-77 35.5-145T295-695l43 43q-56 33-87 90.5T220-439q0 100 66 173t165 84v60Zm60 0v-60q100-12 165-84.5T741-439q0-109-75.5-184.5T481-699h-20l60 60-43 43-133-133 133-133 43 43-60 60h20q134 0 227 93.5T801-439q0 125-83.5 216T511-122Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </Tooltip>
              <span style={{ padding: "5px" }}>
                <Switch
                  style={{
                    backgroundColor: active ? "#50C878" : "#FF0000",
                  }}
                  checked={active}
                  onChange={handleSwitchChange}
                  // disabled={loading}
                  checkedChildren="SUCCESS"
                  unCheckedChildren="FAILED"
                />
              </span>
            </div>
          </div>
        </div>

        <Input.Search
          className="search-input"
          placeholder="Search by..."
          enterButton
          value={searchString}
          onChange={handleSearchChange}
        />
      </div> */}
      <div>
        <Spin spinning={loading}>
          <Table
            size="small"
            rowKey="id"
            dataSource={data}
            columns={active ? columns : failedColumns}
            bordered
            className="table-container"
            pagination={false}
            style={{ margin: "1rem" }}
            onChange={handleSortChange}
            scroll={{
              y: `${remainingViewportHeight(36)}px`,
              x: 1000,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onPageChange}
              pageSizeOptions={[10, 15, 30, 50, 100]}
              // showQuickJumper
              current={currentPage}
              defaultPageSize={pageSize}
              pageSize={pageSize}
              total={itemsLength}
            />
          </div>
        </Spin>
        <AuditFilterModal
          visible={visible}
          handleCancel={() => {
            setVisible(false);
          }}
          handleApply={handleApply}
          resetFields={ResetFields}
          l1Filters={L1Filters}
          setselectedL1Filter={setselectedL1Filter}
          fetchL2Filters={L2Filter}
          l2Filters={L2Filters}
          setselectedL2Filter={setselectedL2Filter}
          selectedL1Filter={selectedL1Filter}
          selectedL2Filter={selectedL2Filter}
          selectedL3Filter={selectedL3Filter}
          setselectedL3Filter={setselectedL3Filter}
          fetchL3Filters={L3Filter}
          l3Filters={L3Filters}
          l1name={l1name}
          l2name={l2name}
          l3name={l3name}
        />
      </div>
    </>
  );
};

export default AuditTable;
